module.exports = "/images/chat-bubbles-read.svg?38bc14fbeb145c080d3c7dacf312be3c";